import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ForgotPasswordPage = () => {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await resetPassword(email);
    if (error) {
      setError(error.message || 'Failed to send reset email');
    } else {
      setSent(true);
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>Reset Password</h1>
        {sent ? (
          <div data-testid="reset-sent-message">
            <div className="success-message" style={{ marginBottom: 16 }}>
              Check your email for a password reset link. It may take a minute to arrive.
            </div>
            <p style={{ fontSize: '0.8125rem', color: 'var(--text-muted)', marginBottom: 16 }}>
              Sent to: <strong>{email}</strong>
            </p>
            <Link to="/login" className="btn-primary btn-full" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
              Back to Sign In
            </Link>
          </div>
        ) : (
          <>
            <p>Enter your email and we'll send you a link to reset your password.</p>
            {error && <div className="error-message" data-testid="forgot-error">{error}</div>}
            <form onSubmit={handleSubmit} className="auth-form" data-testid="forgot-form">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <button type="submit" className="btn-primary btn-full" disabled={loading} data-testid="forgot-submit">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <p className="auth-footer">
              Remember your password? <Link to="/login">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};


export default ForgotPasswordPage;
